import {AppRouter} from "./app/router";
import {ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const App = () => {
  return (
    <>
      <ToastContainer autoClose={2000} closeButton={false} hideProgressBar={true} />
      <AppRouter />
    </>
  );
};

export default App;
